import { createFileRoute } from "@tanstack/react-router";
import { EnrollmentTokensPage } from "@/features/operator/EnrollmentTokensPage";

export const Route = createFileRoute("/app/operator/enrollment-tokens")({ component: EnrollmentTokensPage });
